export const gendersValue = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];

export const maternalEducationValues = [
  { value: "illiterate", label: "Illiterate" },
  { value: "primary", label: "Primary" },
  { value: "madhyamik", label: "Madhyamik" },
  { value: "hs_and_above", label: "HS and above" },
];

export const mothersNutritionValues = [
  { value: "poor", label: "Poor" },
  { value: "fair", label: "Fair" },
  { value: "good", label: "Good" },
];

export const antenatalCheckUpsvalues = [
  { value: "nil", label: "Nil" },
  { value: "1-2", label: "1-2" },
  { value: "3-4", label: "3-4" },
  { value: "5", label: "5" },
];

export const ironValues = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const injectionTetanusToxoidValues = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
];

export const antenatalIllnessOptionValues = [
  "1st_trimester_fever",
  "3rd_trimester_fever",
  "rashes",
  "aph",
  "hypertension",
  "diabetes",
  "anaemia",
  "vaginal_infection",
  "others",
  "none"
];

export const placeOfDeliveryValues = [
  { value: "home", label: "Home" },
  { value: "institution", label: "Institution" },
];
export const yesNoOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const modeOfDeliveryvalues = [
  { value: "nd", label: "ND" },
  { value: "assisted_vaginal", label: "Assisted vaginal" },
  { value: "lucs", label: "LUCS" },
];
export const criedAtBirthValues = [
  { value: "immediate", label: "Immediate" },
  { value: "within_2_minutes", label: "Within 2 minutes" },
  { value: "after_2_minutes", label: "After 2 minutes" },
  { value: "not_known", label: "Not Known" },
  { value: "no", label: "No" },
];
export const resuscitationValues = ["routine_care", "bmv", "cc", "medication"];
export const neonatalProblemsOptionValues = [
  "lbw",
  "preterm",
  "hie",
  "hypothermia",
  "hypoglycaemia",
  "sepsis",
  "respiratory_distress",
  "convulsions",
  "severe_jaundice",
  "neonatal jaundice",
  "none"
];
export const hospitalizationValues = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];
export const breastFeedingValues = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "na", label: "Not Applicable" },
];
export const immunizationValue = [
  { value: "up_to_date", label: "Up-to-date" },
  { value: "partial", label: "Partial" },
  { value: "nil", label: "Nil" },
];
export const relationValues = [
  'Mother',
  'Father',
  'Others'
];

export const advices = {
  A : `•Get a routine Eye Check and Hearing check done (if not done earlier)\n
•Continue Exclusive breast feeding on demand\n
•Maintain Skin-to-skin contact with baby\n
•Handle the baby with affection and care: Caress, stroke and give gentle massage\n
•Smile at, sing to and talk with the baby. Make funny faces \n
•Maintain a healthy home environment: Baby’s room should be clean, safe, bright, well-lit and well ventilated.\n
•Use bright, colourful curtains, bed linen\n
•Hang colourful toys above crib\n
•Allow baby to move all 4 limbs freely\n
•Respond to the baby’s cues consistently and effectively\n
•Maintain proper hygiene: Always wash hands before feeding and after cleaning the baby.\n
•Prevent fall, burns, smothering, choking\n
•No smoking in the house\n
•Take care of maternal mental health and nutrition`,
B : `•Get a routine Eye Check done (if not done earlier)\n
•Get a routine Hearing check done(if not done earlier)\n
•Continue Exclusive breast feeding on demand\n
•Maintain a healthy home environment: Baby’s room should be clean, safe, bright, well-lit and well ventilated.\n
•Use bright, colourful curtains, bed linen\n
•Hang colourful toys above crib\n
•Smile at, sing to and talk with the baby. Make funny faces \n
•Play with your baby with colourful, safe toys, rattles etc.\n
•Allow baby to move all 4 limbs freely\n
•Respond to the baby’s cues consistently and effectively\n
•Maintain proper hygiene: Always wash hands before feeding and after cleaning the baby.\n
•Prevent fall, burns, smothering, choking\n
•No smoking in the house\n
•Take care of maternal mental health and nutrition`,
C: `•Continue  breast feeding on demand\n
•Start Complimentary feeds with home-based semi-solids like suji/ mashed ripe banana/ khichri etc. Start with small amount and gradually increase amount, frequency and thickness.\n
•Promote Responsive feeding: Talk with baby while feeding; no screentime during feeding.\n
•Maintain a healthy home environment: Baby’s room should be clean, safe, bright, well-lit and well ventilated.\n
•Offer safe, large toys of various textures for handling. Show mirror\n
•Allow baby to sit and play\n
•Play with baby. Smile at, sing to and talk with the baby. Make funny faces\n
•Respond to the baby’s cues consistently and effectively\n
•Maintain proper hygiene: Always wash hands before feeding and after cleaning the baby.\n
•Prevent fall, burns, smothering, choking\n
•No smoking in the house\n
•Take care of maternal mental health and nutrition`,
D: `•Continue Complimentary feeds with home-based food, 3-4 times a day. Introduce different textures and flavours. Baby should have cereals, dal, vegetables, fruits, eggs. May introduce fish and meat.\n
•Continue breast feeding on demand\n
•Promote Responsive feeding: Talk with baby while feeding; no screentime during feeding.\n
•Encourage self feeding\n
•Maintain a healthy home environment: Baby’s room should be clean, safe, bright, well-lit and well ventilated.\n
•Give baby safe simple cause & effect toys of various colours, shapes and textures\n
•Engage with your child. How to play with your baby and promote learning:\n
o	Play Peekaboo\n
o	Imitation of actions like waving, clapping\n
o	Show pictures in a picture book\n
o	Teach baby names of common objects and actions\n
•Respond to the baby’s cues consistently and effectively.\n
•Pay attention to his emotions and respond accordingly\n
•Make sure the toys are safe and hazard-free.\n
•Prevent fall, burns, smothering, choking\n
•No smoking in the house\n
•Prevent physical/ emotional abuse \n
•Take care of maternal mental health and nutrition`,
E: `•Home-based food, 4-5 times a day. Introduce different textures and flavours. Baby should have cereals, dal, vegetables, fruits, eggs, fish and meat.\n
•Baby can now eat from the family pot\n
•Promote Responsive feeding: Talk with baby while feeding; no screentime during feeding.\n
•Encourage self feeding and eating together with the family\n
•Give baby safe simple cause & effect toys of various colours, shapes and textures\n
•Engage with your child. How to play with your baby and promote learning:\n
o	Stacking, nesting of objects\n
o	Putting small objects in container and dumping out; poking with one finger\n
o	Initiate imitation and pretend play with doll\n
o	Talk meaningfully with child in small sentences.\n
o	Name common objects\n
•Respond to the baby’s cues consistently and effectively.\n
•Pay attention to his emotions and respond accordingly\n
•Make sure the toys are safe and hazard-free.\n
•Prevent fall, burns, smothering, choking\n
•No smoking in the house\n
•Prevent physical/ emotional abuse \n
•Take care of maternal mental health and nutrition`,
F: `•Home-based food, 4-5 times a day. Introduce different textures and flavours. Baby should have cereals, dal, vegetables, fruits, eggs, fish and meat.\n
•Baby can now eat from the family pot\n
•Promote Responsive feeding: Talk with baby while feeding; no screentime during feeding.\n
•Encourage self feeding and eating together with the family\n
•Give baby safe simple cause & effect toys of various colours, shapes and textures\n
•Engage with your child. How to play with your baby and promote learning:\n
o	 Manipulative play (unscrewing/ fitting/ pulling/pushing etc)\n
o	Scribbling\n
o	Initiate imitation and pretend play with doll\n
o	Play with colours/water/sand etc (supervised)\n
•Respond to the baby’s cues consistently and effectively.\n
•Pay attention to his emotions and respond accordingly \n
•Address unwanted behaviour intelligently by distracting/ ignoring/ setting firm limits as required. Focus on positive parenting\n
•Make sure the toys are safe and hazard-free.\n
•Prevent fall, burns, smothering, choking\n
•No smoking in the house\n
•Prevent physical/ emotional abuse`,
G : `•Home-based food, 4-5 times a day. \n
•Child should eat from his own plate, at the table with the family\n
•Ensure all 7 food groups are included over the day’s meal\n
•No forced feeding\n
•No screentime during meals\n
•Give baby safe simple cause & effect toys of various colours, shapes and textures\n
•Engage with your child. Stimulate child’s curiosity through:\n
o	Manipulative play (unscrewing/ fitting/ pulling/pushing etc)\n
o	Problem solving play\n
o	Pretend play\n
o	Imitation and pretend play with doll\n
o	Play with colours/water/sand etc (supervised)\n
•Talk with the child, tell stories and read books with the child.\n
•Respond to the baby’s cues consistently and effectively.\n
•Pay attention to his emotions and respond accordingly\n
•Make sure the toys are safe and hazard-free.\n
•Prevent fall, burns, smothering, choking\n
•No smoking in the house\n
•Prevent physical/ emotional abuse`,

H : `•Home-based food, 4-5 times a day.\n
•Child should eat from his own plate, at the table with the family\n
•Ensure all 7 food groups are included over the day’s meal\n
•No forced feeding\n
•No screentime during meals\n
•Engage with your child. Stimulate child’s curiosity: answer questions.\n
•Play outdoors with child to promote physical activities.\n
•Encourage interaction with other children.\n
•Help him name  and describe things, count object.\n
•Tell stories.\n
•Read together\n
•Engage in problem solving games and pretend play\n
•Play with colours/water/sand etc (supervised)\n
•Work on prewriting skill development and School readiness\n
•Respond to the baby’s cues consistently and effectively.\n
•Pay attention to his emotions and respond accordingly\n
•Make sure the toys are safe and hazard-free.\n
•Prevent fall, burns, smothering, choking \n
•No smoking in the house\n
•Prevent physical/ emotional abuse`,

I : `•Routine Eye Check to be done\n
•Child should eat from his own plate, at the table with the family\n
•Ensure all 7 food groups are included over the day’s meal\n
•No forced feeding. No screentime during meals\n
•Engage with your child. Stimulate child’s curiosity: answer questions.\n
•Play outdoors with child to promote physical activities.\n
•Encourage interaction with other children.\n
•Promote social rules and empathy\n
•Promote skills for self-help and activities of daily living\n
•Help him name  and describe things, count object.\n
•Tell stories.\n
•Read together\n
•Engage in problem solving games and pretend play \n
•Play with colours/water/sand etc (supervised)\n
•Work on prewriting skill development and School readiness\n
•Respond to the baby’s cues consistently and effectively.\n
•Pay attention to his emotions and respond accordingly  \n
•Make sure the toys are safe and hazard-free.\n
•Prevent fall, burns, smothering, choking \n
•No smoking in the house\n
•Prevent physical/ emotional abuse`,
J: `•Routine Eye Check\n
•Healthy home environment\n
•Promote Responsive feeding \n
•Child eats from his own plate, at the table with the family\n
•Ensure all 7 food groups are included over the day’s meal\n
•No forced feeding\n
•No screentime during meals\n
•Prevent physical/ emotional abuse \n
•Prevent fall, burns, drowning, smothering, choking, road traffic accidents etc\n
•No smoking in the house\n
•Respond to the child’s questions and stimulate his curiosity.\n
•Pay attention to his emotions and respond accordingly\n
•Encourage positive parenting: positive reinforcement, set firm limits, distract from unwanted behaviour.\n
•Do not pamper but avoid harsh discipline.\n
•Promote social rules and empathy\n
•Play outdoors with child to promote physical activities.\n
•Encourage interaction with other children.\n
•Stimulate child’s curiosity: answer questions\n
•Promote self-help and ADL\n
•Promote  pre-writing skills/ scribbling/ colouring\n
•Read together\n
•Work on school readiness\n
•Tell stories.\n
•Problem solving games
`
}

export const BengaliAdvices = {
  A:`• স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন\n
• মায়ের মানসিক স্বাস্থ্য এবং পুষ্টির যত্ন নিন\n
• শুধু মাত্র বুকের দুধ খাওয়ান\n
• ঘরে ধূমপান করবেন না\n
• শিশুকে আপনার বুকের স্পর্শে রাখুন (skin to skin contact)\n
• স্নেহ ও যত্নের সাথে শিশুকে নাড়াচারা করুন\n
• আদর করুন, হাত বুলান এবং মৃদু ম্যাসাজ করুন\n
• শিশুর দিকে তাকিয়ে হাসুন, গান করুন এবং তার সাথে কথা বলুন। মজার মুখ ভঙ্গি করুন\n
• উজ্জ্বল, রঙিন পর্দা, বিছানার চাদর ব্যবহার করুন \n
• খাটের উপরে রঙিন খেলনা ঝুলিয়ে দিন\n
• শিশুকে অবাধে চার হাত পা নাড়াতে দিন
`,
B:`•  চোখের পরীক্ষা করান (যদি আগে না করা হয়ে থাকে )\n
•  শ্রবণশক্তি পরীক্ষা করান (যদি আগে না করা হয়ে থাকে)\n
• শুধু মাত্র বুকের দুধ খাওয়ানো চালিয়ে যান, যখন যেমন শিশু চাইবে \n
• একটি স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন: শিশুর ঘর পরিষ্কার, নিরাপদ, উজ্জ্বল, ভাল আলোযুক্ত এবং ভাল বায়ুচলাচলযুক্ত হওয়া উচিত।\n
•	উজ্জ্বল, রঙিন পর্দা, বিছানার চাদর ব্যবহার করুন\n
• খাটের উপরে রঙিন খেলনা ঝুলিয়ে দিন\n
• শিশুর দিকে তাকিয়ে হাসুন, গান করুন এবং তার সাথে কথা বলুন। মজার মুখভঙ্গি করুন\n
• রঙিন, নিরাপদ খেলনা, র‍্যাটল ইত্যাদি দিয়ে আপনার শিশুর সাথে খেলুন\n
• শিশুকে অবাধে 4টি অঙ্গ নাড়াতে দিন\n
• শিশুর ইঙ্গিতগুলিতে ধারাবাহিকভাবে এবং কার্যকরভাবে সাড়া দিন\n
• সঠিক স্বাস্থ্যবিধি বজায় রাখুন: খাওয়ানোর আগে এবং শিশুকে পরিষ্কার করার পরে সর্বদা হাত ধুয়ে নিন।\n
•	পড়ে যাওয়া, পোড়া, শ্বাসরোধ, শ্বাসরোধ প্রতিরোধ করুন\n
•	ঘরে ধূমপান নিষিদ্ধ\n
• মায়ের মানসিক স্বাস্থ্য এবং পুষ্টির যত্ন নিন
`,
C:`• নিয়মিত চোখের পরীক্ষা (যদি আগে না করা হয়)\n
• স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন \n
• মায়ের মানসিক স্বাস্থ্য এবং পুষ্টির যত্ন নিন\n
• এক বা দুবার ভারী খাবার দিতে শুরু করুন। পাকা কলা চটকে, porridge বা সুজি, পাতলা খিচুড়ী  দিতে পারেন।চামচ দিয়ে অল্প করে খাওয়ান। বুকের দুধ ও খাইয়ে যান।\n
• খাওয়ানোর সময়ে শিশুর প্রতিক্রিয়া লক্ষ্য করুন\n
• সঠিক স্বাস্থ্যবিধি বজায় রাখুন\n
• পড়ে যাওয়া, পুড়ে যাওয়া, শ্বাসরোধ করা, শ্বাসরোধ করা প্রতিরোধ করুন\n
• ঘরে ধূমপান করবেন না\n
• শিশুর ইঙ্গিতগুলিতে ধারাবাহিকভাবে এবং কার্যকরভাবে সাড়া দিন\n
• শিশুর দিকে তাকিয়ে হাসুন, গান করুন এবং তার সাথে কথা বলুন। মজার মুখ করুন। শিশুর আবেগে সারা দিন। \n
• শিশুকে বিভিন্ন টেক্সচারের নিরাপদ, বড় খেলনা (নরম বল, rattle, হালকা blocks, সফট toys) ধরতে ও নাড়াচারা করতে দিন। আয়না দেখান\n
• শিশুকে বসতে উত্সাহিত করুন ও বসিয়ে খেলতে দিন\n
• শিশুর সাথে খেলুন
`,
D:`• স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন\n
• ভারী খাবার দিন, দিনে 3-4 বার। খিচুড়ী, সবজি সেদ্ধ, নরম ফল, সুজি/ দালিয়া , ছানা, ডিমের কুসুম ইত্যাদি দিতে পারেন। ঘন খবর চমছে খাওয়ান \n
• শুকনো খবর যেমন মুড়ি নিজে হাতে খাওয়ার সুযোগ দিন। \n
• খাওয়ানোর সময়ে শিশুর প্রতিক্রিয়া লক্ষ্য করুন, তার সঙ্গে কথা বলুন। \n
• কোনো রকম শারীরিক/মানসিক নির্যাতন প্রতিরোধ করুন\n
• পড়ে যাওয়া, পুড়ে যাওয়া, ডুবে যাওয়া, শ্বাসরোধ করা, শ্বাসরোধ করা ইত্যাদি প্রতিরোধ করুন\n
• ঘরে ধূমপান করবেন না\n
• শিশুর ইঙ্গিতগুলিতে ধারাবাহিকভাবে এবং কার্যকরভাবে সাড়া দিন\n
• তার আবেগের প্রতি মনোযোগ দিন এবং সেই অনুযায়ী সাড়া দিন\n
•	উঠে বসর ও হাম টানার সুযোগ দিন \n
• টুকি বা peek -a -boo খেলুন\n
• হাত নাড়ানো, হাততালি দেওয়ার মতো ক্রিয়াগুলির অনুকরণ করতে শেখান \n
• ছবির বইতে ছবি দেখান\n
• সাধারণ জিনিস এবং ক্রিয়াগুলির নাম শিশুকে শেখান\n
• বিভিন্ন রঙ, আকার এবং টেক্সচারের নিরাপদ খেলনা শিশুকে দিন। Cause and  effect খেলনা দিন 
`,
E:`• স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন\n
• ভারী খাবার দিন, দিনে 4-5 বার। খিচুড়ী, সবজি সেদ্ধ, নরম ফল, সুজি/ দালিয়া , ছানা, ডিম, মাছ, মাংস ইত্যাদি দিতে পারেন। খাবারে স্বাদ ও বৈচিত্র আনুন, চিবিয়ে খবর সুযোগ দিন. \n
•  নিজে হাতে খাওয়ার সুযোগ দিন। \n
•	বুকের দুধ বন্ধ করবন না \n
• খাওয়ানোর সময়ে শিশুর প্রতিক্রিয়া লক্ষ্য করুন, তার সঙ্গে কথা বলুন। \n
• কোনো রকম শারীরিক/মানসিক নির্যাতন প্রতিরোধ করুন\n
• পড়ে যাওয়া, পুড়ে যাওয়া, ডুবে যাওয়া, শ্বাসরোধ করা, শ্বাসরোধ করা ইত্যাদি প্রতিরোধ করুন\n
• ঘরে ধূমপান করবেন না\n
• শিশুর ইঙ্গিতগুলিতে ধারাবাহিকভাবে এবং কার্যকরভাবে সাড়া দিন\n
• তার আবেগের প্রতি মনোযোগ দিন এবং সেই অনুযায়ী সাড়া দিন\n
• শিশুকে অবাধে চলাফেরা করতে দিন \n
• এমন খেলনা দিন যা সে সাজেতে, stack করতে, কোনো পাত্রে ভরতে বা বার করতে পারবে। \n
• অনুকরণ মূলক খেলা খেলুন শিশুর সাথে, যেমন পুতুলকে খাওয়ানো, ঘুম পড়ানো \n
• ছোট ছোট বাক্যে শিশুর সাথে অর্থপূর্ণভাবে কথা বলুন।\n
• সাধারণ জিনিসগুলির নাম শেখান 
`,
F:`• স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন\n
• ভারী খাবার দিন, দিনে 4-5 বার। খিচুড়ী, সবজি সেদ্ধ, নরম ফল, সুজি/ দালিয়া , ছানা, ডিম, মাছ, মাংস ইত্যাদি দিতে পারেন। খাবারে স্বাদ ও বৈচিত্র আনুন, চিবিয়ে খবর সুযোগ দিন. \n
•  নিজে হাতে খাওয়ার সুযোগ দিন। \n
•	বুকের দুধ বন্ধ করবন না \n
• খাওয়ানোর সময়ে শিশুর প্রতিক্রিয়া লক্ষ্য করুন, তার সঙ্গে কথা বলুন। \n
• কোনো রকম শারীরিক/মানসিক নির্যাতন প্রতিরোধ করুন\n
• পড়ে যাওয়া, পুড়ে যাওয়া, ডুবে যাওয়া, শ্বাসরোধ করা, শ্বাসরোধ করা ইত্যাদি প্রতিরোধ করুন\n
• ঘরে ধূমপান করবেন না\n
• শিশুর ইঙ্গিতগুলিতে ধারাবাহিকভাবে এবং কার্যকরভাবে সাড়া দিন\n
• তার আবেগের প্রতি মনোযোগ দিন এবং সেই অনুযায়ী সাড়া দিন\n
• শিশুকে অবাধে চলাফেরা করতে দিন \n
• এমন খেলনা দিন যা সে সাজেতে, stack করতে, কোনো পাত্রে ভরতে বা বার করতে পারবে। \n
• অনুকরণ মূলক খেলা খেলুন শিশুর সাথে, যেমন পুতুলকে খাওয়ানো, ঘুম পড়ানো \n
• Manipulative  খেলা (স্ক্রু খোলা/ফিটিং/টানা/ঠেলা ইত্যাদি)\n
• কাগজে আঁকিবুকি  কাটতে দিন \n
• অনুকরণ মূলক খেলা খেলুন শিশুর সাথে। \n
• রঙ/জল/বালি ইত্যাদি নিয়ে খেলার  (তত্ত্বাবধানে) সুযোগ দিন 
`,
G:`•	স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন\n
• ভারী খাবার দিন, দিনে 4-5 বার। খিচুড়ী, সবজি সেদ্ধ, নরম ফল, সুজি/ দালিয়া , ছানা, ডিম, মাছ, মাংস ইত্যাদি দিতে পারেন। খাবারে স্বাদ ও বৈচিত্র আনুন, চিবিয়ে খবর সুযোগ দিন.\n 
•  নিশ্চিত করুন যে দিনের খাবারে ৭টি খাবারের গ্রুপই অন্তর্ভুক্ত করা হয়েছে\n
•	নিজে হাতে, নিজের প্লেট থেকে খাওয়ার সুযোগ দিন। বাড়ির সকলের সঙ্গে বসিয়ে, খেতে দিন\n
• খাওয়ানোর সময়ে শিশুর প্রতিক্রিয়া লক্ষ্য করুন, তার সঙ্গে কথা বলুন।\n
• জোর করে খাওয়াবেন  না\n
• খাবারের সময় ফোন বা tv দেখবেন  না\n
• শারীরিক/মানসিক নির্যাতন প্রতিরোধ করুন\n
• পড়ে যাওয়া, পুড়ে যাওয়া, ডুবে যাওয়া, শ্বাসরোধ করা ইত্যাদি প্রতিরোধ করুন\n
• ঘরে ধূমপান করবেন না\n
• শিশুর ইঙ্গিতের প্রতি ধারাবাহিকভাবে এবং কার্যকরভাবে সাড়া দিন\n
• তার আবেগের প্রতি মনোযোগ দিন এবং সেই অনুযায়ী সাড়া দিন\n
• অবাঞ্ছিত আচরণ মোকাবেলা করার টিপস: ইতিবাচক অভিভাবকত্ব (positive parenting)\n
• শিশুর কৌতূহল জাগিয়ে তুলুন\n
• কৌশলী খেলা (স্ক্রু খুলে ফেলা/ ফিটিং করা/ টানা/ঠেলা দেওয়া ইত্যাদি) দিন\n
• সমস্যা সমাধানের খেলা দিন\n
• ভান করা বা অনুকরণ মূলক  খেলা খেলুন\n
• রঙ/জল/বালি ইত্যাদি নিয়ে খেলা (তত্ত্বাবধানে)
`,
H:`•	স্বাস্থ্যকর বাড়ির পরিবেশ বজায় রাখুন\n
• ভারী খাবার দিন, দিনে 4-5 বার। খিচুড়ী, সবজি সেদ্ধ, নরম ফল, সুজি/ দালিয়া , ছানা, ডিম, মাছ, মাংস ইত্যাদি দিতে পারেন। খাবারে স্বাদ ও বৈচিত্র আনুন, চিবিয়ে খবর সুযোগ দিন. \n
•  নিশ্চিত করুন যে দিনের খাবারে ৭টি খাবারের গ্রুপই অন্তর্ভুক্ত করা হয়েছে \n
•	নিজে হাতে, নিজের প্লেট থেকে খাওয়ার সুযোগ দিন। বাড়ির সকলের সঙ্গে বসিয়ে, খেতে দিন \n
• খাওয়ানোর সময়ে শিশুর প্রতিক্রিয়া লক্ষ্য করুন, তার সঙ্গে কথা বলুন। \n
• জোর করে খাওয়াবেন  না\n
• খাবারের সময় ফোন বা tv দেখবেন  না\n
• শারীরিক/মানসিক নির্যাতন প্রতিরোধ করুন\n
• পড়ে যাওয়া, পুড়ে যাওয়া, ডুবে যাওয়া, শ্বাসরোধ করা ইত্যাদি প্রতিরোধ করুন\n
• ঘরে ধূমপান করবেন না\n
• শিশুর ইঙ্গিতের প্রতি ধারাবাহিকভাবে এবং কার্যকরভাবে সাড়া দিন\n
• তার আবেগের প্রতি মনোযোগ দিন এবং সেই অনুযায়ী সাড়া দিন\n
• অবাঞ্ছিত আচরণ মোকাবেলা করার টিপস: ইতিবাচক অভিভাবকত্ব (positive parenting)\n
• শিশুর কৌতূহল জাগিয়ে তুলুন\n
• কৌশলী খেলা (স্ক্রু খুলে ফেলা/ ফিটিং করা/ টানা/ঠেলা দেওয়া ইত্যাদি) দিন \n
• সমস্যা সমাধানের খেলা দিন \n
• ভান করা বা অনুকরণ মূলক  খেলা খেলুন \n
• রঙ/জল/বালি ইত্যাদি নিয়ে খেলা (তত্ত্বাবধানে)
`,
I:`• নিয়ম মাফিক  চোখের পরীক্ষা করান \n
• স্বাস্থ্যকর বাড়ির পরিবেশ\n
• নিজে নিজে খাওয়াতে উৎসাহিত করুন\n
• শিশু তার নিজের প্লেট থেকে, পরিবারের সাথে টেবিলে খায়\n
• নিশ্চিত করুন যে দিনের খাবারের সময় 7 টি খাবারের গ্রুপই অন্তর্ভুক্ত করা হয়েছে\n
• জোরপূর্বক খাওয়ানো যাবে না\n
• খাবারের সময় স্ক্রিন টাইম থাকবে না\n
• শারীরিক/মানসিক নির্যাতন প্রতিরোধ করুন\n
• পড়ে যাওয়া, পুড়ে যাওয়া, ডুবে যাওয়া, শ্বাসরোধ করা, শ্বাসরোধ করা ইত্যাদি প্রতিরোধ করুন\n
• ঘরে ধূমপান করবেন না\n
• শিশুর ইঙ্গিতগুলির ধারাবাহিকভাবে এবং কার্যকরভাবে প্রতিক্রিয়া জানান\n
• তার আবেগের প্রতি মনোযোগ দিন এবং সেই অনুযায়ী প্রতিক্রিয়া জানান\n
• অবাঞ্ছিত আচরণ মোকাবেলা করার টিপস: ইতিবাচক অভিভাবকত্ব\n
• সামাজিক নিয়ম পালন এবং সহানুভূতি শীল হতে শেখান \n
• শারীরিক সক্ষমতার জন্য শিশুর সাথে বাইরে খেলুন।\n
• অন্যান্য শিশুদের সাথে মিশতে  উৎসাহিত করুন।\n
• শিশুর কৌতূহল জাগিয়ে তুলুন: প্রশ্নের উত্তর দিন\n
• দৈনন্দিন কাজ, যেমন খাওয়া, জামা -জুতো পরা, brush করা নিজে করতে উত্সাহ দিন \n
• আঙ্গুলের সূক্ষ্ম কাজে উত্সাহ দিন, যেমন পুঁতি গাঁথা, রঙ করা, পেন্সিল ধরা.\n
• একসাথে বই পড়ুন\n
• স্কুলের প্রস্তুতির উপর কাজ করুন\n
• গল্প বলুন।\n
• সমস্যা সমাধান মূলক  গেম খেলুন 
`
}